export const getters = {
    loginAttempts: state => state.attempts,
    usernames: state => state.username,
    profileImg: state => state.profilePic,
    roleuserModules: state => state.usermodules
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/auth/getters.js